import React from 'react';

interface HowItWorksStepProps {
  imageSrc: string;
  alt: string;
  title: string;
  text: string;
  reverse?: boolean; // second step reverses on md
}

export const HowItWorksStep: React.FC<HowItWorksStepProps> = ({ imageSrc, alt, title, text, reverse }) => {
  return (
    <div className={`flex flex-col ${reverse ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-8`}>
      <div className="w-full md:w-1/2 flex justify-center">
        <img src={imageSrc} alt={alt} className="rounded-xl shadow-lg w-full aspect-video object-cover" />
      </div>
      <div className="w-full md:w-1/2">
        <h3 className="text-2xl font-bold text-wedding-text-title mb-3">{title}</h3>
        <p className="text-gray-600">{text}</p>
      </div>
    </div>
  );
};

